import { ref, listAll, deleteObject } from "firebase/storage";
import { doc, deleteDoc } from "firebase/firestore";
import { storage, db } from "../../../../firebase";

/**
 * Recursively deletes all storage objects under the given folder reference.
 * @param {import("firebase/storage").StorageReference} folderRef
 */
async function deleteFolderStorageRecursive(folderRef) {
  const listResult = await listAll(folderRef);
  const deletePromises = [];

  listResult.items.forEach((itemRef) => {
    deletePromises.push(deleteObject(itemRef));
  });

  listResult.prefixes.forEach((subfolderRef) => {
    deletePromises.push(deleteFolderStorageRecursive(subfolderRef));
  });

  await Promise.all(deletePromises);
}

/**
 * Deletes a folder document from Firestore and all associated storage objects.
 * @param {Object} folder - Folder object containing userId and folderId.
 * @param {string} folder.userId
 * @param {string} folder.folderId
 */
export async function deleteFolder(folder) {
  // Delete Firestore folder document
  const folderDocRef = doc(
    db,
    "users",
    folder.userId,
    "folders",
    folder.folderId
  );
  await deleteDoc(folderDocRef);

  // Delete all storage references under the folder path
  // Assuming folder storage path is "users/{userId}/folders/{folderId}/"
  const folderStoragePath = `users/${folder.userId}/folders/${folder.folderId}/`;
  const folderStorageRef = ref(storage, folderStoragePath);

  await deleteFolderStorageRecursive(folderStorageRef);
}
